<div class="box-digital-card-wrapper">
  <div class="box-digital-card-front">
    <ng-content select="[cardFront]"></ng-content>
  </div>
  <div *ngIf="flippable" class="box-digital-card-back">
    <ng-content select="[cardBack]"></ng-content>
  </div>
</div>
